/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Record Service API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  BusinessObject,
  CollectionFacetQueryRequest,
  CollectionFacetQueryResponse,
  CollectionQueryRequest,
  CollectionQueryResponse,
  DeleteRecordByIdParams,
  GetRecordByIdParams,
  GetRecordByIdWithMetadataParams,
  GetRecordCollectionParams,
  GetRecordCollectionWithMetadataParams,
  GetRecordDereferencedParams,
  LifecycleStatusResponse,
  MigrateLifecycleRecordBody,
  RebindLifecycleRecordBody,
  RecordCollectionResponse,
  RecordCollectionWithMetadataResponse,
  RecordWithMetadataResponse,
  WorkflowDefinitionLifecycleCommandBody,
} from "../model";

import { customFetch } from "../../../custom-fetch";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type getRecordCollectionResponse200 = {
  data: RecordCollectionResponse | CollectionQueryResponse;
  status: 200;
};

export type getRecordCollectionResponse400 = {
  data: void;
  status: 400;
};

export type getRecordCollectionResponse404 = {
  data: void;
  status: 404;
};

export type getRecordCollectionResponseSuccess = getRecordCollectionResponse200 & {
  headers: Headers;
};
export type getRecordCollectionResponseError = (
  | getRecordCollectionResponse400
  | getRecordCollectionResponse404
) & {
  headers: Headers;
};

export type getRecordCollectionResponse =
  | getRecordCollectionResponseSuccess
  | getRecordCollectionResponseError;

export const getGetRecordCollectionUrl = (
  resource: string,
  resourceVersion: string,
  params?: GetRecordCollectionParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/record-service/v1/${resource}/${resourceVersion}?${stringifiedParams}`
    : `/record-service/v1/${resource}/${resourceVersion}`;
};

/**
 * @summary Get all business objects for a resource version
 */
export const getRecordCollection = async (
  resource: string,
  resourceVersion: string,
  params?: GetRecordCollectionParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<getRecordCollectionResponse> => {
  return customFetch<getRecordCollectionResponse>(
    getGetRecordCollectionUrl(resource, resourceVersion, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetRecordCollectionMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getRecordCollection>>,
    TError,
    { resource: string; resourceVersion: string; params?: GetRecordCollectionParams },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getRecordCollection>>,
  TError,
  { resource: string; resourceVersion: string; params?: GetRecordCollectionParams },
  TContext
> => {
  const mutationKey = ["getRecordCollection"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getRecordCollection>>,
    { resource: string; resourceVersion: string; params?: GetRecordCollectionParams }
  > = (props) => {
    const { resource, resourceVersion, params } = props ?? {};

    return getRecordCollection(resource, resourceVersion, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetRecordCollectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof getRecordCollection>>
>;

export type GetRecordCollectionMutationError = void;

/**
 * @summary Get all business objects for a resource version
 */
export const useGetRecordCollection = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getRecordCollection>>,
      TError,
      { resource: string; resourceVersion: string; params?: GetRecordCollectionParams },
      TContext
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getRecordCollection>>,
  TError,
  { resource: string; resourceVersion: string; params?: GetRecordCollectionParams },
  TContext
> => {
  return useMutation(getGetRecordCollectionMutationOptions(options), queryClient);
};
export type createRecordVersionResponse202 = {
  data: void;
  status: 202;
};

export type createRecordVersionResponseSuccess = createRecordVersionResponse202 & {
  headers: Headers;
};
export type createRecordVersionResponse = createRecordVersionResponseSuccess;

export const getCreateRecordVersionUrl = (resource: string, resourceVersion: string) => {
  return `/record-service/v1/${resource}/${resourceVersion}`;
};

/**
 * Accepted asynchronously. The response includes an `Operation-Location`
 * header pointing at `/record-service/v1/operations/{operationId}` which
 * can be polled (see `getOperationStatus`) for terminal status.
 * @summary Create a new business object version
 */
export const createRecordVersion = async (
  resource: string,
  resourceVersion: string,
  businessObject: BusinessObject,
  options?: Parameters<typeof customFetch>[1],
): Promise<createRecordVersionResponse> => {
  return customFetch<createRecordVersionResponse>(
    getCreateRecordVersionUrl(resource, resourceVersion),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(businessObject),
    },
  );
};

export const getCreateRecordVersionQueryKey = (
  resource: string,
  resourceVersion: string,
  businessObject?: BusinessObject,
) => {
  return ["POST", `/record-service/v1/${resource}/${resourceVersion}`, businessObject] as const;
};

export const getCreateRecordVersionQueryOptions = <
  TData = Awaited<ReturnType<typeof createRecordVersion>>,
  TError = unknown,
>(
  resource: string,
  resourceVersion: string,
  businessObject: BusinessObject,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof createRecordVersion>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getCreateRecordVersionQueryKey(resource, resourceVersion, businessObject);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof createRecordVersion>>> = ({ signal }) =>
    createRecordVersion(resource, resourceVersion, businessObject, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled:
      resource !== null &&
      resource !== undefined &&
      resourceVersion !== null &&
      resourceVersion !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof createRecordVersion>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type CreateRecordVersionQueryResult = NonNullable<
  Awaited<ReturnType<typeof createRecordVersion>>
>;
export type CreateRecordVersionQueryError = unknown;

export function useCreateRecordVersion<
  TData = Awaited<ReturnType<typeof createRecordVersion>>,
  TError = unknown,
>(
  resource: string,
  resourceVersion: string,
  businessObject: BusinessObject,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof createRecordVersion>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof createRecordVersion>>,
          TError,
          Awaited<ReturnType<typeof createRecordVersion>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCreateRecordVersion<
  TData = Awaited<ReturnType<typeof createRecordVersion>>,
  TError = unknown,
>(
  resource: string,
  resourceVersion: string,
  businessObject: BusinessObject,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof createRecordVersion>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof createRecordVersion>>,
          TError,
          Awaited<ReturnType<typeof createRecordVersion>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCreateRecordVersion<
  TData = Awaited<ReturnType<typeof createRecordVersion>>,
  TError = unknown,
>(
  resource: string,
  resourceVersion: string,
  businessObject: BusinessObject,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof createRecordVersion>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Create a new business object version
 */

export function useCreateRecordVersion<
  TData = Awaited<ReturnType<typeof createRecordVersion>>,
  TError = unknown,
>(
  resource: string,
  resourceVersion: string,
  businessObject: BusinessObject,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof createRecordVersion>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getCreateRecordVersionQueryOptions(
    resource,
    resourceVersion,
    businessObject,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export type queryRecordCollectionResponse200 = {
  data: CollectionQueryResponse;
  status: 200;
};

export type queryRecordCollectionResponse400 = {
  data: void;
  status: 400;
};

export type queryRecordCollectionResponse404 = {
  data: void;
  status: 404;
};

export type queryRecordCollectionResponseSuccess = queryRecordCollectionResponse200 & {
  headers: Headers;
};
export type queryRecordCollectionResponseError = (
  | queryRecordCollectionResponse400
  | queryRecordCollectionResponse404
) & {
  headers: Headers;
};

export type queryRecordCollectionResponse =
  | queryRecordCollectionResponseSuccess
  | queryRecordCollectionResponseError;

export const getQueryRecordCollectionUrl = (resource: string, resourceVersion: string) => {
  return `/record-service/v1/${resource}/${resourceVersion}/query`;
};

/**
 * @summary Query business object collection with filter AST and pagination
 */
export const queryRecordCollection = async (
  resource: string,
  resourceVersion: string,
  collectionQueryRequest?: CollectionQueryRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<queryRecordCollectionResponse> => {
  return customFetch<queryRecordCollectionResponse>(
    getQueryRecordCollectionUrl(resource, resourceVersion),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(collectionQueryRequest),
    },
  );
};

export const getQueryRecordCollectionQueryKey = (
  resource: string,
  resourceVersion: string,
  collectionQueryRequest?: CollectionQueryRequest,
) => {
  return [
    "POST",
    `/record-service/v1/${resource}/${resourceVersion}/query`,
    collectionQueryRequest,
  ] as const;
};

export const getQueryRecordCollectionQueryOptions = <
  TData = Awaited<ReturnType<typeof queryRecordCollection>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  collectionQueryRequest?: CollectionQueryRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof queryRecordCollection>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getQueryRecordCollectionQueryKey(resource, resourceVersion, collectionQueryRequest);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof queryRecordCollection>>> = ({ signal }) =>
    queryRecordCollection(resource, resourceVersion, collectionQueryRequest, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled:
      resource !== null &&
      resource !== undefined &&
      resourceVersion !== null &&
      resourceVersion !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof queryRecordCollection>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type QueryRecordCollectionQueryResult = NonNullable<
  Awaited<ReturnType<typeof queryRecordCollection>>
>;
export type QueryRecordCollectionQueryError = void;

export function useQueryRecordCollection<
  TData = Awaited<ReturnType<typeof queryRecordCollection>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  collectionQueryRequest: undefined | CollectionQueryRequest,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof queryRecordCollection>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof queryRecordCollection>>,
          TError,
          Awaited<ReturnType<typeof queryRecordCollection>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useQueryRecordCollection<
  TData = Awaited<ReturnType<typeof queryRecordCollection>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  collectionQueryRequest?: CollectionQueryRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof queryRecordCollection>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof queryRecordCollection>>,
          TError,
          Awaited<ReturnType<typeof queryRecordCollection>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useQueryRecordCollection<
  TData = Awaited<ReturnType<typeof queryRecordCollection>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  collectionQueryRequest?: CollectionQueryRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof queryRecordCollection>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Query business object collection with filter AST and pagination
 */

export function useQueryRecordCollection<
  TData = Awaited<ReturnType<typeof queryRecordCollection>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  collectionQueryRequest?: CollectionQueryRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof queryRecordCollection>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getQueryRecordCollectionQueryOptions(
    resource,
    resourceVersion,
    collectionQueryRequest,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export type queryRecordCollectionFacetsResponse200 = {
  data: CollectionFacetQueryResponse;
  status: 200;
};

export type queryRecordCollectionFacetsResponse400 = {
  data: void;
  status: 400;
};

export type queryRecordCollectionFacetsResponse404 = {
  data: void;
  status: 404;
};

export type queryRecordCollectionFacetsResponseSuccess = queryRecordCollectionFacetsResponse200 & {
  headers: Headers;
};
export type queryRecordCollectionFacetsResponseError = (
  | queryRecordCollectionFacetsResponse400
  | queryRecordCollectionFacetsResponse404
) & {
  headers: Headers;
};

export type queryRecordCollectionFacetsResponse =
  | queryRecordCollectionFacetsResponseSuccess
  | queryRecordCollectionFacetsResponseError;

export const getQueryRecordCollectionFacetsUrl = (resource: string, resourceVersion: string) => {
  return `/record-service/v1/${resource}/${resourceVersion}/query/facets`;
};

/**
 * @summary Lazy-load facet buckets for a single column (substring type-ahead)
 */
export const queryRecordCollectionFacets = async (
  resource: string,
  resourceVersion: string,
  collectionFacetQueryRequest: CollectionFacetQueryRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<queryRecordCollectionFacetsResponse> => {
  return customFetch<queryRecordCollectionFacetsResponse>(
    getQueryRecordCollectionFacetsUrl(resource, resourceVersion),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(collectionFacetQueryRequest),
    },
  );
};

export const getQueryRecordCollectionFacetsQueryKey = (
  resource: string,
  resourceVersion: string,
  collectionFacetQueryRequest?: CollectionFacetQueryRequest,
) => {
  return [
    "POST",
    `/record-service/v1/${resource}/${resourceVersion}/query/facets`,
    collectionFacetQueryRequest,
  ] as const;
};

export const getQueryRecordCollectionFacetsQueryOptions = <
  TData = Awaited<ReturnType<typeof queryRecordCollectionFacets>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  collectionFacetQueryRequest: CollectionFacetQueryRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof queryRecordCollectionFacets>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getQueryRecordCollectionFacetsQueryKey(resource, resourceVersion, collectionFacetQueryRequest);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof queryRecordCollectionFacets>>> = ({
    signal,
  }) =>
    queryRecordCollectionFacets(resource, resourceVersion, collectionFacetQueryRequest, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled:
      resource !== null &&
      resource !== undefined &&
      resourceVersion !== null &&
      resourceVersion !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof queryRecordCollectionFacets>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type QueryRecordCollectionFacetsQueryResult = NonNullable<
  Awaited<ReturnType<typeof queryRecordCollectionFacets>>
>;
export type QueryRecordCollectionFacetsQueryError = void;

export function useQueryRecordCollectionFacets<
  TData = Awaited<ReturnType<typeof queryRecordCollectionFacets>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  collectionFacetQueryRequest: CollectionFacetQueryRequest,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof queryRecordCollectionFacets>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof queryRecordCollectionFacets>>,
          TError,
          Awaited<ReturnType<typeof queryRecordCollectionFacets>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useQueryRecordCollectionFacets<
  TData = Awaited<ReturnType<typeof queryRecordCollectionFacets>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  collectionFacetQueryRequest: CollectionFacetQueryRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof queryRecordCollectionFacets>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof queryRecordCollectionFacets>>,
          TError,
          Awaited<ReturnType<typeof queryRecordCollectionFacets>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useQueryRecordCollectionFacets<
  TData = Awaited<ReturnType<typeof queryRecordCollectionFacets>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  collectionFacetQueryRequest: CollectionFacetQueryRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof queryRecordCollectionFacets>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Lazy-load facet buckets for a single column (substring type-ahead)
 */

export function useQueryRecordCollectionFacets<
  TData = Awaited<ReturnType<typeof queryRecordCollectionFacets>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  collectionFacetQueryRequest: CollectionFacetQueryRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof queryRecordCollectionFacets>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getQueryRecordCollectionFacetsQueryOptions(
    resource,
    resourceVersion,
    collectionFacetQueryRequest,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export type createRecordVersionSyncResponse201 = {
  data: BusinessObject;
  status: 201;
};

export type createRecordVersionSyncResponseSuccess = createRecordVersionSyncResponse201 & {
  headers: Headers;
};
export type createRecordVersionSyncResponse = createRecordVersionSyncResponseSuccess;

export const getCreateRecordVersionSyncUrl = (resource: string, resourceVersion: string) => {
  return `/record-service/v1/${resource}/${resourceVersion}/sync`;
};

/**
 * @summary Create a new business object version synchronously
 */
export const createRecordVersionSync = async (
  resource: string,
  resourceVersion: string,
  businessObject: BusinessObject,
  options?: Parameters<typeof customFetch>[1],
): Promise<createRecordVersionSyncResponse> => {
  return customFetch<createRecordVersionSyncResponse>(
    getCreateRecordVersionSyncUrl(resource, resourceVersion),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(businessObject),
    },
  );
};

export const getCreateRecordVersionSyncQueryKey = (
  resource: string,
  resourceVersion: string,
  businessObject?: BusinessObject,
) => {
  return [
    "POST",
    `/record-service/v1/${resource}/${resourceVersion}/sync`,
    businessObject,
  ] as const;
};

export const getCreateRecordVersionSyncQueryOptions = <
  TData = Awaited<ReturnType<typeof createRecordVersionSync>>,
  TError = unknown,
>(
  resource: string,
  resourceVersion: string,
  businessObject: BusinessObject,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof createRecordVersionSync>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getCreateRecordVersionSyncQueryKey(resource, resourceVersion, businessObject);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof createRecordVersionSync>>> = ({
    signal,
  }) =>
    createRecordVersionSync(resource, resourceVersion, businessObject, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled:
      resource !== null &&
      resource !== undefined &&
      resourceVersion !== null &&
      resourceVersion !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof createRecordVersionSync>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type CreateRecordVersionSyncQueryResult = NonNullable<
  Awaited<ReturnType<typeof createRecordVersionSync>>
>;
export type CreateRecordVersionSyncQueryError = unknown;

export function useCreateRecordVersionSync<
  TData = Awaited<ReturnType<typeof createRecordVersionSync>>,
  TError = unknown,
>(
  resource: string,
  resourceVersion: string,
  businessObject: BusinessObject,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof createRecordVersionSync>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof createRecordVersionSync>>,
          TError,
          Awaited<ReturnType<typeof createRecordVersionSync>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCreateRecordVersionSync<
  TData = Awaited<ReturnType<typeof createRecordVersionSync>>,
  TError = unknown,
>(
  resource: string,
  resourceVersion: string,
  businessObject: BusinessObject,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof createRecordVersionSync>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof createRecordVersionSync>>,
          TError,
          Awaited<ReturnType<typeof createRecordVersionSync>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCreateRecordVersionSync<
  TData = Awaited<ReturnType<typeof createRecordVersionSync>>,
  TError = unknown,
>(
  resource: string,
  resourceVersion: string,
  businessObject: BusinessObject,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof createRecordVersionSync>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Create a new business object version synchronously
 */

export function useCreateRecordVersionSync<
  TData = Awaited<ReturnType<typeof createRecordVersionSync>>,
  TError = unknown,
>(
  resource: string,
  resourceVersion: string,
  businessObject: BusinessObject,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof createRecordVersionSync>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getCreateRecordVersionSyncQueryOptions(
    resource,
    resourceVersion,
    businessObject,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export type getRecordCollectionWithMetadataResponse200 = {
  data: RecordCollectionWithMetadataResponse;
  status: 200;
};

export type getRecordCollectionWithMetadataResponse404 = {
  data: void;
  status: 404;
};

export type getRecordCollectionWithMetadataResponseSuccess =
  getRecordCollectionWithMetadataResponse200 & {
    headers: Headers;
  };
export type getRecordCollectionWithMetadataResponseError =
  getRecordCollectionWithMetadataResponse404 & {
    headers: Headers;
  };

export type getRecordCollectionWithMetadataResponse =
  | getRecordCollectionWithMetadataResponseSuccess
  | getRecordCollectionWithMetadataResponseError;

export const getGetRecordCollectionWithMetadataUrl = (
  resource: string,
  resourceVersion: string,
  params?: GetRecordCollectionWithMetadataParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/record-service/v1/${resource}/${resourceVersion}/metadata?${stringifiedParams}`
    : `/record-service/v1/${resource}/${resourceVersion}/metadata`;
};

/**
 * @summary Get all business objects for a resource version including stored metadata
 */
export const getRecordCollectionWithMetadata = async (
  resource: string,
  resourceVersion: string,
  params?: GetRecordCollectionWithMetadataParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<getRecordCollectionWithMetadataResponse> => {
  return customFetch<getRecordCollectionWithMetadataResponse>(
    getGetRecordCollectionWithMetadataUrl(resource, resourceVersion, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetRecordCollectionWithMetadataMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getRecordCollectionWithMetadata>>,
    TError,
    { resource: string; resourceVersion: string; params?: GetRecordCollectionWithMetadataParams },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getRecordCollectionWithMetadata>>,
  TError,
  { resource: string; resourceVersion: string; params?: GetRecordCollectionWithMetadataParams },
  TContext
> => {
  const mutationKey = ["getRecordCollectionWithMetadata"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getRecordCollectionWithMetadata>>,
    { resource: string; resourceVersion: string; params?: GetRecordCollectionWithMetadataParams }
  > = (props) => {
    const { resource, resourceVersion, params } = props ?? {};

    return getRecordCollectionWithMetadata(resource, resourceVersion, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetRecordCollectionWithMetadataMutationResult = NonNullable<
  Awaited<ReturnType<typeof getRecordCollectionWithMetadata>>
>;

export type GetRecordCollectionWithMetadataMutationError = void;

/**
 * @summary Get all business objects for a resource version including stored metadata
 */
export const useGetRecordCollectionWithMetadata = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getRecordCollectionWithMetadata>>,
      TError,
      { resource: string; resourceVersion: string; params?: GetRecordCollectionWithMetadataParams },
      TContext
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getRecordCollectionWithMetadata>>,
  TError,
  { resource: string; resourceVersion: string; params?: GetRecordCollectionWithMetadataParams },
  TContext
> => {
  return useMutation(getGetRecordCollectionWithMetadataMutationOptions(options), queryClient);
};
export type getRecordByIdResponse200 = {
  data: BusinessObject;
  status: 200;
};

export type getRecordByIdResponse404 = {
  data: void;
  status: 404;
};

export type getRecordByIdResponseSuccess = getRecordByIdResponse200 & {
  headers: Headers;
};
export type getRecordByIdResponseError = getRecordByIdResponse404 & {
  headers: Headers;
};

export type getRecordByIdResponse = getRecordByIdResponseSuccess | getRecordByIdResponseError;

export const getGetRecordByIdUrl = (
  resource: string,
  resourceVersion: string,
  pk: string,
  params?: GetRecordByIdParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/record-service/v1/${resource}/${resourceVersion}/${pk}?${stringifiedParams}`
    : `/record-service/v1/${resource}/${resourceVersion}/${pk}`;
};

/**
 * @summary Get a specific business object by primary key
 */
export const getRecordById = async (
  resource: string,
  resourceVersion: string,
  pk: string,
  params?: GetRecordByIdParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<getRecordByIdResponse> => {
  return customFetch<getRecordByIdResponse>(
    getGetRecordByIdUrl(resource, resourceVersion, pk, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetRecordByIdMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getRecordById>>,
    TError,
    { resource: string; resourceVersion: string; pk: string; params?: GetRecordByIdParams },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getRecordById>>,
  TError,
  { resource: string; resourceVersion: string; pk: string; params?: GetRecordByIdParams },
  TContext
> => {
  const mutationKey = ["getRecordById"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getRecordById>>,
    { resource: string; resourceVersion: string; pk: string; params?: GetRecordByIdParams }
  > = (props) => {
    const { resource, resourceVersion, pk, params } = props ?? {};

    return getRecordById(resource, resourceVersion, pk, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetRecordByIdMutationResult = NonNullable<Awaited<ReturnType<typeof getRecordById>>>;

export type GetRecordByIdMutationError = void;

/**
 * @summary Get a specific business object by primary key
 */
export const useGetRecordById = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getRecordById>>,
      TError,
      { resource: string; resourceVersion: string; pk: string; params?: GetRecordByIdParams },
      TContext
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getRecordById>>,
  TError,
  { resource: string; resourceVersion: string; pk: string; params?: GetRecordByIdParams },
  TContext
> => {
  return useMutation(getGetRecordByIdMutationOptions(options), queryClient);
};
export type updateRecordByIdResponse202 = {
  data: void;
  status: 202;
};

export type updateRecordByIdResponse404 = {
  data: void;
  status: 404;
};

export type updateRecordByIdResponseSuccess = updateRecordByIdResponse202 & {
  headers: Headers;
};
export type updateRecordByIdResponseError = updateRecordByIdResponse404 & {
  headers: Headers;
};

export type updateRecordByIdResponse =
  | updateRecordByIdResponseSuccess
  | updateRecordByIdResponseError;

export const getUpdateRecordByIdUrl = (resource: string, resourceVersion: string, pk: string) => {
  return `/record-service/v1/${resource}/${resourceVersion}/${pk}`;
};

/**
 * Accepted asynchronously. The response includes an `Operation-Location`
 * header pointing at `/record-service/v1/operations/{operationId}` which
 * can be polled (see `getOperationStatus`) for terminal status.
 * @summary Update a specific business object
 */
export const updateRecordById = async (
  resource: string,
  resourceVersion: string,
  pk: string,
  businessObject: BusinessObject,
  options?: Parameters<typeof customFetch>[1],
): Promise<updateRecordByIdResponse> => {
  return customFetch<updateRecordByIdResponse>(
    getUpdateRecordByIdUrl(resource, resourceVersion, pk),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(businessObject),
    },
  );
};

export const getUpdateRecordByIdQueryKey = (
  resource: string,
  resourceVersion: string,
  pk: string,
  businessObject?: BusinessObject,
) => {
  return [
    "PUT",
    `/record-service/v1/${resource}/${resourceVersion}/${pk}`,
    businessObject,
  ] as const;
};

export const getUpdateRecordByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof updateRecordById>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  businessObject: BusinessObject,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof updateRecordById>>, TError, TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getUpdateRecordByIdQueryKey(resource, resourceVersion, pk, businessObject);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof updateRecordById>>> = ({ signal }) =>
    updateRecordById(resource, resourceVersion, pk, businessObject, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled:
      resource !== null &&
      resource !== undefined &&
      resourceVersion !== null &&
      resourceVersion !== undefined &&
      pk !== null &&
      pk !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof updateRecordById>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type UpdateRecordByIdQueryResult = NonNullable<Awaited<ReturnType<typeof updateRecordById>>>;
export type UpdateRecordByIdQueryError = void;

export function useUpdateRecordById<
  TData = Awaited<ReturnType<typeof updateRecordById>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  businessObject: BusinessObject,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof updateRecordById>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof updateRecordById>>,
          TError,
          Awaited<ReturnType<typeof updateRecordById>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useUpdateRecordById<
  TData = Awaited<ReturnType<typeof updateRecordById>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  businessObject: BusinessObject,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof updateRecordById>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof updateRecordById>>,
          TError,
          Awaited<ReturnType<typeof updateRecordById>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useUpdateRecordById<
  TData = Awaited<ReturnType<typeof updateRecordById>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  businessObject: BusinessObject,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof updateRecordById>>, TError, TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Update a specific business object
 */

export function useUpdateRecordById<
  TData = Awaited<ReturnType<typeof updateRecordById>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  businessObject: BusinessObject,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof updateRecordById>>, TError, TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getUpdateRecordByIdQueryOptions(
    resource,
    resourceVersion,
    pk,
    businessObject,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export type deleteRecordByIdResponse204 = {
  data: void;
  status: 204;
};

export type deleteRecordByIdResponse400 = {
  data: void;
  status: 400;
};

export type deleteRecordByIdResponse404 = {
  data: void;
  status: 404;
};

export type deleteRecordByIdResponseSuccess = deleteRecordByIdResponse204 & {
  headers: Headers;
};
export type deleteRecordByIdResponseError = (
  | deleteRecordByIdResponse400
  | deleteRecordByIdResponse404
) & {
  headers: Headers;
};

export type deleteRecordByIdResponse =
  | deleteRecordByIdResponseSuccess
  | deleteRecordByIdResponseError;

export const getDeleteRecordByIdUrl = (
  resource: string,
  resourceVersion: string,
  pk: string,
  params?: DeleteRecordByIdParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/record-service/v1/${resource}/${resourceVersion}/${pk}?${stringifiedParams}`
    : `/record-service/v1/${resource}/${resourceVersion}/${pk}`;
};

/**
 * Removes the record from the active API surface while retaining its row and platform
 * metadata for audit, restore, and future delayed purge. Reads hide soft-deleted records
 * by default; use `recordState=deleted` or `recordState=all` on read endpoints to inspect
 * tombstoned records. Use `deleteMode=hard` only when the caller must physically remove
 * the active record immediately; hard delete emits the same delete completion event as
 * soft delete.
 * @summary Soft-delete a specific business object
 */
export const deleteRecordById = async (
  resource: string,
  resourceVersion: string,
  pk: string,
  params?: DeleteRecordByIdParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<deleteRecordByIdResponse> => {
  return customFetch<deleteRecordByIdResponse>(
    getDeleteRecordByIdUrl(resource, resourceVersion, pk, params),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDeleteRecordByIdQueryKey = (
  resource: string,
  resourceVersion: string,
  pk: string,
  params?: DeleteRecordByIdParams,
) => {
  return [
    "DELETE",
    `/record-service/v1/${resource}/${resourceVersion}/${pk}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getDeleteRecordByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof deleteRecordById>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  params?: DeleteRecordByIdParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteRecordById>>, TError, TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDeleteRecordByIdQueryKey(resource, resourceVersion, pk, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof deleteRecordById>>> = ({ signal }) =>
    deleteRecordById(resource, resourceVersion, pk, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled:
      resource !== null &&
      resource !== undefined &&
      resourceVersion !== null &&
      resourceVersion !== undefined &&
      pk !== null &&
      pk !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof deleteRecordById>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type DeleteRecordByIdQueryResult = NonNullable<Awaited<ReturnType<typeof deleteRecordById>>>;
export type DeleteRecordByIdQueryError = void;

export function useDeleteRecordById<
  TData = Awaited<ReturnType<typeof deleteRecordById>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  params: undefined | DeleteRecordByIdParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteRecordById>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof deleteRecordById>>,
          TError,
          Awaited<ReturnType<typeof deleteRecordById>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDeleteRecordById<
  TData = Awaited<ReturnType<typeof deleteRecordById>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  params?: DeleteRecordByIdParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteRecordById>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof deleteRecordById>>,
          TError,
          Awaited<ReturnType<typeof deleteRecordById>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDeleteRecordById<
  TData = Awaited<ReturnType<typeof deleteRecordById>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  params?: DeleteRecordByIdParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteRecordById>>, TError, TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Soft-delete a specific business object
 */

export function useDeleteRecordById<
  TData = Awaited<ReturnType<typeof deleteRecordById>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  params?: DeleteRecordByIdParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteRecordById>>, TError, TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getDeleteRecordByIdQueryOptions(
    resource,
    resourceVersion,
    pk,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export type restoreRecordByIdResponse200 = {
  data: BusinessObject;
  status: 200;
};

export type restoreRecordByIdResponse404 = {
  data: void;
  status: 404;
};

export type restoreRecordByIdResponseSuccess = restoreRecordByIdResponse200 & {
  headers: Headers;
};
export type restoreRecordByIdResponseError = restoreRecordByIdResponse404 & {
  headers: Headers;
};

export type restoreRecordByIdResponse =
  | restoreRecordByIdResponseSuccess
  | restoreRecordByIdResponseError;

export const getRestoreRecordByIdUrl = (resource: string, resourceVersion: string, pk: string) => {
  return `/record-service/v1/${resource}/${resourceVersion}/${pk}/restore`;
};

/**
 * Restores a soft-deleted record to the active API surface and emits the same create
 * completion event type used by POST so projections, idempotency, and on-create
 * platform reactions can re-run against the restored record.
 * @summary Restore a soft-deleted business object
 */
export const restoreRecordById = async (
  resource: string,
  resourceVersion: string,
  pk: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<restoreRecordByIdResponse> => {
  return customFetch<restoreRecordByIdResponse>(
    getRestoreRecordByIdUrl(resource, resourceVersion, pk),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getRestoreRecordByIdQueryKey = (
  resource: string,
  resourceVersion: string,
  pk: string,
) => {
  return ["POST", `/record-service/v1/${resource}/${resourceVersion}/${pk}/restore`] as const;
};

export const getRestoreRecordByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof restoreRecordById>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof restoreRecordById>>, TError, TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getRestoreRecordByIdQueryKey(resource, resourceVersion, pk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof restoreRecordById>>> = ({ signal }) =>
    restoreRecordById(resource, resourceVersion, pk, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled:
      resource !== null &&
      resource !== undefined &&
      resourceVersion !== null &&
      resourceVersion !== undefined &&
      pk !== null &&
      pk !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof restoreRecordById>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type RestoreRecordByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof restoreRecordById>>
>;
export type RestoreRecordByIdQueryError = void;

export function useRestoreRecordById<
  TData = Awaited<ReturnType<typeof restoreRecordById>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof restoreRecordById>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof restoreRecordById>>,
          TError,
          Awaited<ReturnType<typeof restoreRecordById>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRestoreRecordById<
  TData = Awaited<ReturnType<typeof restoreRecordById>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof restoreRecordById>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof restoreRecordById>>,
          TError,
          Awaited<ReturnType<typeof restoreRecordById>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRestoreRecordById<
  TData = Awaited<ReturnType<typeof restoreRecordById>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof restoreRecordById>>, TError, TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Restore a soft-deleted business object
 */

export function useRestoreRecordById<
  TData = Awaited<ReturnType<typeof restoreRecordById>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof restoreRecordById>>, TError, TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getRestoreRecordByIdQueryOptions(resource, resourceVersion, pk, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export type adoptLifecycleRecordResponse200 = {
  data: void;
  status: 200;
};

export type adoptLifecycleRecordResponse404 = {
  data: void;
  status: 404;
};

export type adoptLifecycleRecordResponse409 = {
  data: void;
  status: 409;
};

export type adoptLifecycleRecordResponseSuccess = adoptLifecycleRecordResponse200 & {
  headers: Headers;
};
export type adoptLifecycleRecordResponseError = (
  | adoptLifecycleRecordResponse404
  | adoptLifecycleRecordResponse409
) & {
  headers: Headers;
};

export type adoptLifecycleRecordResponse =
  | adoptLifecycleRecordResponseSuccess
  | adoptLifecycleRecordResponseError;

export const getAdoptLifecycleRecordUrl = (
  resource: string,
  resourceVersion: string,
  pk: string,
) => {
  return `/record-service/v1/${resource}/${resourceVersion}/${pk}/lifecycle/adopt`;
};

/**
 * Creates a linked instance at the record's current lifecycle value without replaying
 * history or entry activities. Unmappable records are quarantined.
 * @summary Adopt an unpaired record onto a Record Service-authoritative machine
 */
export const adoptLifecycleRecord = async (
  resource: string,
  resourceVersion: string,
  pk: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<adoptLifecycleRecordResponse> => {
  return customFetch<adoptLifecycleRecordResponse>(
    getAdoptLifecycleRecordUrl(resource, resourceVersion, pk),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getAdoptLifecycleRecordQueryKey = (
  resource: string,
  resourceVersion: string,
  pk: string,
) => {
  return [
    "POST",
    `/record-service/v1/${resource}/${resourceVersion}/${pk}/lifecycle/adopt`,
  ] as const;
};

export const getAdoptLifecycleRecordQueryOptions = <
  TData = Awaited<ReturnType<typeof adoptLifecycleRecord>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adoptLifecycleRecord>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdoptLifecycleRecordQueryKey(resource, resourceVersion, pk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adoptLifecycleRecord>>> = ({ signal }) =>
    adoptLifecycleRecord(resource, resourceVersion, pk, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled:
      resource !== null &&
      resource !== undefined &&
      resourceVersion !== null &&
      resourceVersion !== undefined &&
      pk !== null &&
      pk !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof adoptLifecycleRecord>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type AdoptLifecycleRecordQueryResult = NonNullable<
  Awaited<ReturnType<typeof adoptLifecycleRecord>>
>;
export type AdoptLifecycleRecordQueryError = void;

export function useAdoptLifecycleRecord<
  TData = Awaited<ReturnType<typeof adoptLifecycleRecord>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adoptLifecycleRecord>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adoptLifecycleRecord>>,
          TError,
          Awaited<ReturnType<typeof adoptLifecycleRecord>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdoptLifecycleRecord<
  TData = Awaited<ReturnType<typeof adoptLifecycleRecord>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adoptLifecycleRecord>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adoptLifecycleRecord>>,
          TError,
          Awaited<ReturnType<typeof adoptLifecycleRecord>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdoptLifecycleRecord<
  TData = Awaited<ReturnType<typeof adoptLifecycleRecord>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adoptLifecycleRecord>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Adopt an unpaired record onto a Record Service-authoritative machine
 */

export function useAdoptLifecycleRecord<
  TData = Awaited<ReturnType<typeof adoptLifecycleRecord>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adoptLifecycleRecord>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdoptLifecycleRecordQueryOptions(resource, resourceVersion, pk, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export type migrateLifecycleRecordResponse200 = {
  data: void;
  status: 200;
};

export type migrateLifecycleRecordResponse409 = {
  data: void;
  status: 409;
};

export type migrateLifecycleRecordResponseSuccess = migrateLifecycleRecordResponse200 & {
  headers: Headers;
};
export type migrateLifecycleRecordResponseError = migrateLifecycleRecordResponse409 & {
  headers: Headers;
};

export type migrateLifecycleRecordResponse =
  | migrateLifecycleRecordResponseSuccess
  | migrateLifecycleRecordResponseError;

export const getMigrateLifecycleRecordUrl = (
  resource: string,
  resourceVersion: string,
  pk: string,
) => {
  return `/record-service/v1/${resource}/${resourceVersion}/${pk}/lifecycle/migrate`;
};

/**
 * @summary Pin a stable instance to an explicit published definition version
 */
export const migrateLifecycleRecord = async (
  resource: string,
  resourceVersion: string,
  pk: string,
  migrateLifecycleRecordBody: MigrateLifecycleRecordBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<migrateLifecycleRecordResponse> => {
  return customFetch<migrateLifecycleRecordResponse>(
    getMigrateLifecycleRecordUrl(resource, resourceVersion, pk),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(migrateLifecycleRecordBody),
    },
  );
};

export const getMigrateLifecycleRecordQueryKey = (
  resource: string,
  resourceVersion: string,
  pk: string,
  migrateLifecycleRecordBody?: MigrateLifecycleRecordBody,
) => {
  return [
    "POST",
    `/record-service/v1/${resource}/${resourceVersion}/${pk}/lifecycle/migrate`,
    migrateLifecycleRecordBody,
  ] as const;
};

export const getMigrateLifecycleRecordQueryOptions = <
  TData = Awaited<ReturnType<typeof migrateLifecycleRecord>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  migrateLifecycleRecordBody: MigrateLifecycleRecordBody,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof migrateLifecycleRecord>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getMigrateLifecycleRecordQueryKey(resource, resourceVersion, pk, migrateLifecycleRecordBody);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof migrateLifecycleRecord>>> = ({ signal }) =>
    migrateLifecycleRecord(resource, resourceVersion, pk, migrateLifecycleRecordBody, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled:
      resource !== null &&
      resource !== undefined &&
      resourceVersion !== null &&
      resourceVersion !== undefined &&
      pk !== null &&
      pk !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof migrateLifecycleRecord>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type MigrateLifecycleRecordQueryResult = NonNullable<
  Awaited<ReturnType<typeof migrateLifecycleRecord>>
>;
export type MigrateLifecycleRecordQueryError = void;

export function useMigrateLifecycleRecord<
  TData = Awaited<ReturnType<typeof migrateLifecycleRecord>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  migrateLifecycleRecordBody: MigrateLifecycleRecordBody,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof migrateLifecycleRecord>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof migrateLifecycleRecord>>,
          TError,
          Awaited<ReturnType<typeof migrateLifecycleRecord>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMigrateLifecycleRecord<
  TData = Awaited<ReturnType<typeof migrateLifecycleRecord>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  migrateLifecycleRecordBody: MigrateLifecycleRecordBody,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof migrateLifecycleRecord>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof migrateLifecycleRecord>>,
          TError,
          Awaited<ReturnType<typeof migrateLifecycleRecord>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMigrateLifecycleRecord<
  TData = Awaited<ReturnType<typeof migrateLifecycleRecord>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  migrateLifecycleRecordBody: MigrateLifecycleRecordBody,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof migrateLifecycleRecord>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Pin a stable instance to an explicit published definition version
 */

export function useMigrateLifecycleRecord<
  TData = Awaited<ReturnType<typeof migrateLifecycleRecord>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  migrateLifecycleRecordBody: MigrateLifecycleRecordBody,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof migrateLifecycleRecord>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getMigrateLifecycleRecordQueryOptions(
    resource,
    resourceVersion,
    pk,
    migrateLifecycleRecordBody,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export type rebindLifecycleRecordResponse200 = {
  data: void;
  status: 200;
};

export type rebindLifecycleRecordResponse409 = {
  data: void;
  status: 409;
};

export type rebindLifecycleRecordResponseSuccess = rebindLifecycleRecordResponse200 & {
  headers: Headers;
};
export type rebindLifecycleRecordResponseError = rebindLifecycleRecordResponse409 & {
  headers: Headers;
};

export type rebindLifecycleRecordResponse =
  | rebindLifecycleRecordResponseSuccess
  | rebindLifecycleRecordResponseError;

export const getRebindLifecycleRecordUrl = (
  resource: string,
  resourceVersion: string,
  pk: string,
) => {
  return `/record-service/v1/${resource}/${resourceVersion}/${pk}/lifecycle/rebind`;
};

/**
 * @summary Explicit audited type-record discriminator rebind
 */
export const rebindLifecycleRecord = async (
  resource: string,
  resourceVersion: string,
  pk: string,
  rebindLifecycleRecordBody: RebindLifecycleRecordBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<rebindLifecycleRecordResponse> => {
  return customFetch<rebindLifecycleRecordResponse>(
    getRebindLifecycleRecordUrl(resource, resourceVersion, pk),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(rebindLifecycleRecordBody),
    },
  );
};

export const getRebindLifecycleRecordQueryKey = (
  resource: string,
  resourceVersion: string,
  pk: string,
  rebindLifecycleRecordBody?: RebindLifecycleRecordBody,
) => {
  return [
    "POST",
    `/record-service/v1/${resource}/${resourceVersion}/${pk}/lifecycle/rebind`,
    rebindLifecycleRecordBody,
  ] as const;
};

export const getRebindLifecycleRecordQueryOptions = <
  TData = Awaited<ReturnType<typeof rebindLifecycleRecord>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  rebindLifecycleRecordBody: RebindLifecycleRecordBody,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof rebindLifecycleRecord>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getRebindLifecycleRecordQueryKey(resource, resourceVersion, pk, rebindLifecycleRecordBody);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof rebindLifecycleRecord>>> = ({ signal }) =>
    rebindLifecycleRecord(resource, resourceVersion, pk, rebindLifecycleRecordBody, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled:
      resource !== null &&
      resource !== undefined &&
      resourceVersion !== null &&
      resourceVersion !== undefined &&
      pk !== null &&
      pk !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof rebindLifecycleRecord>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type RebindLifecycleRecordQueryResult = NonNullable<
  Awaited<ReturnType<typeof rebindLifecycleRecord>>
>;
export type RebindLifecycleRecordQueryError = void;

export function useRebindLifecycleRecord<
  TData = Awaited<ReturnType<typeof rebindLifecycleRecord>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  rebindLifecycleRecordBody: RebindLifecycleRecordBody,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof rebindLifecycleRecord>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof rebindLifecycleRecord>>,
          TError,
          Awaited<ReturnType<typeof rebindLifecycleRecord>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRebindLifecycleRecord<
  TData = Awaited<ReturnType<typeof rebindLifecycleRecord>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  rebindLifecycleRecordBody: RebindLifecycleRecordBody,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof rebindLifecycleRecord>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof rebindLifecycleRecord>>,
          TError,
          Awaited<ReturnType<typeof rebindLifecycleRecord>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRebindLifecycleRecord<
  TData = Awaited<ReturnType<typeof rebindLifecycleRecord>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  rebindLifecycleRecordBody: RebindLifecycleRecordBody,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof rebindLifecycleRecord>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Explicit audited type-record discriminator rebind
 */

export function useRebindLifecycleRecord<
  TData = Awaited<ReturnType<typeof rebindLifecycleRecord>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  rebindLifecycleRecordBody: RebindLifecycleRecordBody,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof rebindLifecycleRecord>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getRebindLifecycleRecordQueryOptions(
    resource,
    resourceVersion,
    pk,
    rebindLifecycleRecordBody,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export type purgeRecordByIdResponse200 = {
  data: LifecycleStatusResponse;
  status: 200;
};

export type purgeRecordByIdResponse404 = {
  data: void;
  status: 404;
};

export type purgeRecordByIdResponse409 = {
  data: void;
  status: 409;
};

export type purgeRecordByIdResponseSuccess = purgeRecordByIdResponse200 & {
  headers: Headers;
};
export type purgeRecordByIdResponseError = (
  | purgeRecordByIdResponse404
  | purgeRecordByIdResponse409
) & {
  headers: Headers;
};

export type purgeRecordByIdResponse = purgeRecordByIdResponseSuccess | purgeRecordByIdResponseError;

export const getPurgeRecordByIdUrl = (resource: string, resourceVersion: string, pk: string) => {
  return `/record-service/v1/${resource}/${resourceVersion}/${pk}/purge`;
};

/**
 * Permanently removes a record that has already been soft-deleted. Active records are
 * rejected with `409 Conflict`; callers must soft-delete first. Purge emits a distinct
 * purge completion event.
 * @summary Physically purge a soft-deleted business object
 */
export const purgeRecordById = async (
  resource: string,
  resourceVersion: string,
  pk: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<purgeRecordByIdResponse> => {
  return customFetch<purgeRecordByIdResponse>(
    getPurgeRecordByIdUrl(resource, resourceVersion, pk),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getPurgeRecordByIdQueryKey = (
  resource: string,
  resourceVersion: string,
  pk: string,
) => {
  return ["DELETE", `/record-service/v1/${resource}/${resourceVersion}/${pk}/purge`] as const;
};

export const getPurgeRecordByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof purgeRecordById>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof purgeRecordById>>, TError, TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPurgeRecordByIdQueryKey(resource, resourceVersion, pk);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof purgeRecordById>>> = ({ signal }) =>
    purgeRecordById(resource, resourceVersion, pk, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled:
      resource !== null &&
      resource !== undefined &&
      resourceVersion !== null &&
      resourceVersion !== undefined &&
      pk !== null &&
      pk !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof purgeRecordById>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type PurgeRecordByIdQueryResult = NonNullable<Awaited<ReturnType<typeof purgeRecordById>>>;
export type PurgeRecordByIdQueryError = void;

export function usePurgeRecordById<
  TData = Awaited<ReturnType<typeof purgeRecordById>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof purgeRecordById>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof purgeRecordById>>,
          TError,
          Awaited<ReturnType<typeof purgeRecordById>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePurgeRecordById<
  TData = Awaited<ReturnType<typeof purgeRecordById>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof purgeRecordById>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof purgeRecordById>>,
          TError,
          Awaited<ReturnType<typeof purgeRecordById>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePurgeRecordById<
  TData = Awaited<ReturnType<typeof purgeRecordById>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof purgeRecordById>>, TError, TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Physically purge a soft-deleted business object
 */

export function usePurgeRecordById<
  TData = Awaited<ReturnType<typeof purgeRecordById>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof purgeRecordById>>, TError, TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPurgeRecordByIdQueryOptions(resource, resourceVersion, pk, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export type getLifecycleAvailableTransitionsResponse200 = {
  data: void;
  status: 200;
};

export type getLifecycleAvailableTransitionsResponse400 = {
  data: void;
  status: 400;
};

export type getLifecycleAvailableTransitionsResponse404 = {
  data: void;
  status: 404;
};

export type getLifecycleAvailableTransitionsResponse409 = {
  data: void;
  status: 409;
};

export type getLifecycleAvailableTransitionsResponse503 = {
  data: void;
  status: 503;
};

export type getLifecycleAvailableTransitionsResponseSuccess =
  getLifecycleAvailableTransitionsResponse200 & {
    headers: Headers;
  };
export type getLifecycleAvailableTransitionsResponseError = (
  | getLifecycleAvailableTransitionsResponse400
  | getLifecycleAvailableTransitionsResponse404
  | getLifecycleAvailableTransitionsResponse409
  | getLifecycleAvailableTransitionsResponse503
) & {
  headers: Headers;
};

export type getLifecycleAvailableTransitionsResponse =
  | getLifecycleAvailableTransitionsResponseSuccess
  | getLifecycleAvailableTransitionsResponseError;

export const getGetLifecycleAvailableTransitionsUrl = (
  resource: string,
  resourceVersion: string,
  pk: string,
) => {
  return `/record-service/v1/${resource}/${resourceVersion}/${pk}/lifecycle/transitions`;
};

/**
 * Returns safe outgoing topology from the exact pinned instance. Guarded routes are
 * marked for commit-time evaluation; this read never creates a lifecycle command and
 * a later POST, PUT, or PATCH always re-evaluates every rule.
 * @summary List advisory transitions for a lifecycle-bound record
 */
export const getLifecycleAvailableTransitions = async (
  resource: string,
  resourceVersion: string,
  pk: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<getLifecycleAvailableTransitionsResponse> => {
  return customFetch<getLifecycleAvailableTransitionsResponse>(
    getGetLifecycleAvailableTransitionsUrl(resource, resourceVersion, pk),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetLifecycleAvailableTransitionsMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getLifecycleAvailableTransitions>>,
    TError,
    { resource: string; resourceVersion: string; pk: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getLifecycleAvailableTransitions>>,
  TError,
  { resource: string; resourceVersion: string; pk: string },
  TContext
> => {
  const mutationKey = ["getLifecycleAvailableTransitions"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getLifecycleAvailableTransitions>>,
    { resource: string; resourceVersion: string; pk: string }
  > = (props) => {
    const { resource, resourceVersion, pk } = props ?? {};

    return getLifecycleAvailableTransitions(resource, resourceVersion, pk, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetLifecycleAvailableTransitionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof getLifecycleAvailableTransitions>>
>;

export type GetLifecycleAvailableTransitionsMutationError = void;

/**
 * @summary List advisory transitions for a lifecycle-bound record
 */
export const useGetLifecycleAvailableTransitions = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getLifecycleAvailableTransitions>>,
      TError,
      { resource: string; resourceVersion: string; pk: string },
      TContext
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getLifecycleAvailableTransitions>>,
  TError,
  { resource: string; resourceVersion: string; pk: string },
  TContext
> => {
  return useMutation(getGetLifecycleAvailableTransitionsMutationOptions(options), queryClient);
};
export type updateRecordByIdSyncResponse200 = {
  data: BusinessObject;
  status: 200;
};

export type updateRecordByIdSyncResponse404 = {
  data: void;
  status: 404;
};

export type updateRecordByIdSyncResponseSuccess = updateRecordByIdSyncResponse200 & {
  headers: Headers;
};
export type updateRecordByIdSyncResponseError = updateRecordByIdSyncResponse404 & {
  headers: Headers;
};

export type updateRecordByIdSyncResponse =
  | updateRecordByIdSyncResponseSuccess
  | updateRecordByIdSyncResponseError;

export const getUpdateRecordByIdSyncUrl = (
  resource: string,
  resourceVersion: string,
  pk: string,
) => {
  return `/record-service/v1/${resource}/${resourceVersion}/${pk}/sync`;
};

/**
 * @summary Update a specific business object synchronously
 */
export const updateRecordByIdSync = async (
  resource: string,
  resourceVersion: string,
  pk: string,
  businessObject: BusinessObject,
  options?: Parameters<typeof customFetch>[1],
): Promise<updateRecordByIdSyncResponse> => {
  return customFetch<updateRecordByIdSyncResponse>(
    getUpdateRecordByIdSyncUrl(resource, resourceVersion, pk),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(businessObject),
    },
  );
};

export const getUpdateRecordByIdSyncQueryKey = (
  resource: string,
  resourceVersion: string,
  pk: string,
  businessObject?: BusinessObject,
) => {
  return [
    "PUT",
    `/record-service/v1/${resource}/${resourceVersion}/${pk}/sync`,
    businessObject,
  ] as const;
};

export const getUpdateRecordByIdSyncQueryOptions = <
  TData = Awaited<ReturnType<typeof updateRecordByIdSync>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  businessObject: BusinessObject,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof updateRecordByIdSync>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getUpdateRecordByIdSyncQueryKey(resource, resourceVersion, pk, businessObject);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof updateRecordByIdSync>>> = ({ signal }) =>
    updateRecordByIdSync(resource, resourceVersion, pk, businessObject, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled:
      resource !== null &&
      resource !== undefined &&
      resourceVersion !== null &&
      resourceVersion !== undefined &&
      pk !== null &&
      pk !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof updateRecordByIdSync>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type UpdateRecordByIdSyncQueryResult = NonNullable<
  Awaited<ReturnType<typeof updateRecordByIdSync>>
>;
export type UpdateRecordByIdSyncQueryError = void;

export function useUpdateRecordByIdSync<
  TData = Awaited<ReturnType<typeof updateRecordByIdSync>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  businessObject: BusinessObject,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof updateRecordByIdSync>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof updateRecordByIdSync>>,
          TError,
          Awaited<ReturnType<typeof updateRecordByIdSync>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useUpdateRecordByIdSync<
  TData = Awaited<ReturnType<typeof updateRecordByIdSync>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  businessObject: BusinessObject,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof updateRecordByIdSync>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof updateRecordByIdSync>>,
          TError,
          Awaited<ReturnType<typeof updateRecordByIdSync>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useUpdateRecordByIdSync<
  TData = Awaited<ReturnType<typeof updateRecordByIdSync>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  businessObject: BusinessObject,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof updateRecordByIdSync>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Update a specific business object synchronously
 */

export function useUpdateRecordByIdSync<
  TData = Awaited<ReturnType<typeof updateRecordByIdSync>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  businessObject: BusinessObject,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof updateRecordByIdSync>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getUpdateRecordByIdSyncQueryOptions(
    resource,
    resourceVersion,
    pk,
    businessObject,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export type getRecordByIdWithMetadataResponse200 = {
  data: RecordWithMetadataResponse;
  status: 200;
};

export type getRecordByIdWithMetadataResponse404 = {
  data: void;
  status: 404;
};

export type getRecordByIdWithMetadataResponseSuccess = getRecordByIdWithMetadataResponse200 & {
  headers: Headers;
};
export type getRecordByIdWithMetadataResponseError = getRecordByIdWithMetadataResponse404 & {
  headers: Headers;
};

export type getRecordByIdWithMetadataResponse =
  | getRecordByIdWithMetadataResponseSuccess
  | getRecordByIdWithMetadataResponseError;

export const getGetRecordByIdWithMetadataUrl = (
  resource: string,
  resourceVersion: string,
  pk: string,
  params?: GetRecordByIdWithMetadataParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/record-service/v1/${resource}/${resourceVersion}/${pk}/metadata?${stringifiedParams}`
    : `/record-service/v1/${resource}/${resourceVersion}/${pk}/metadata`;
};

/**
 * @summary Get a specific business object by primary key including stored metadata
 */
export const getRecordByIdWithMetadata = async (
  resource: string,
  resourceVersion: string,
  pk: string,
  params?: GetRecordByIdWithMetadataParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<getRecordByIdWithMetadataResponse> => {
  return customFetch<getRecordByIdWithMetadataResponse>(
    getGetRecordByIdWithMetadataUrl(resource, resourceVersion, pk, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetRecordByIdWithMetadataMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getRecordByIdWithMetadata>>,
    TError,
    {
      resource: string;
      resourceVersion: string;
      pk: string;
      params?: GetRecordByIdWithMetadataParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getRecordByIdWithMetadata>>,
  TError,
  {
    resource: string;
    resourceVersion: string;
    pk: string;
    params?: GetRecordByIdWithMetadataParams;
  },
  TContext
> => {
  const mutationKey = ["getRecordByIdWithMetadata"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getRecordByIdWithMetadata>>,
    {
      resource: string;
      resourceVersion: string;
      pk: string;
      params?: GetRecordByIdWithMetadataParams;
    }
  > = (props) => {
    const { resource, resourceVersion, pk, params } = props ?? {};

    return getRecordByIdWithMetadata(resource, resourceVersion, pk, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetRecordByIdWithMetadataMutationResult = NonNullable<
  Awaited<ReturnType<typeof getRecordByIdWithMetadata>>
>;

export type GetRecordByIdWithMetadataMutationError = void;

/**
 * @summary Get a specific business object by primary key including stored metadata
 */
export const useGetRecordByIdWithMetadata = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getRecordByIdWithMetadata>>,
      TError,
      {
        resource: string;
        resourceVersion: string;
        pk: string;
        params?: GetRecordByIdWithMetadataParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getRecordByIdWithMetadata>>,
  TError,
  {
    resource: string;
    resourceVersion: string;
    pk: string;
    params?: GetRecordByIdWithMetadataParams;
  },
  TContext
> => {
  return useMutation(getGetRecordByIdWithMetadataMutationOptions(options), queryClient);
};
export type getRecordDereferencedResponse200 = {
  data: BusinessObject;
  status: 200;
};

export type getRecordDereferencedResponse400 = {
  data: void;
  status: 400;
};

export type getRecordDereferencedResponse404 = {
  data: void;
  status: 404;
};

export type getRecordDereferencedResponseSuccess = getRecordDereferencedResponse200 & {
  headers: Headers;
};
export type getRecordDereferencedResponseError = (
  | getRecordDereferencedResponse400
  | getRecordDereferencedResponse404
) & {
  headers: Headers;
};

export type getRecordDereferencedResponse =
  | getRecordDereferencedResponseSuccess
  | getRecordDereferencedResponseError;

export const getGetRecordDereferencedUrl = (
  resource: string,
  resourceVersion: string,
  pk: string,
  params?: GetRecordDereferencedParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/record-service/v1/${resource}/${resourceVersion}/${pk}/dereference?${stringifiedParams}`
    : `/record-service/v1/${resource}/${resourceVersion}/${pk}/dereference`;
};

/**
 * @summary Get a business object with recursively dereferenced outbound relationships
 */
export const getRecordDereferenced = async (
  resource: string,
  resourceVersion: string,
  pk: string,
  params?: GetRecordDereferencedParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<getRecordDereferencedResponse> => {
  return customFetch<getRecordDereferencedResponse>(
    getGetRecordDereferencedUrl(resource, resourceVersion, pk, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetRecordDereferencedMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getRecordDereferenced>>,
    TError,
    { resource: string; resourceVersion: string; pk: string; params?: GetRecordDereferencedParams },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getRecordDereferenced>>,
  TError,
  { resource: string; resourceVersion: string; pk: string; params?: GetRecordDereferencedParams },
  TContext
> => {
  const mutationKey = ["getRecordDereferenced"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getRecordDereferenced>>,
    { resource: string; resourceVersion: string; pk: string; params?: GetRecordDereferencedParams }
  > = (props) => {
    const { resource, resourceVersion, pk, params } = props ?? {};

    return getRecordDereferenced(resource, resourceVersion, pk, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetRecordDereferencedMutationResult = NonNullable<
  Awaited<ReturnType<typeof getRecordDereferenced>>
>;

export type GetRecordDereferencedMutationError = void;

/**
 * @summary Get a business object with recursively dereferenced outbound relationships
 */
export const useGetRecordDereferenced = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getRecordDereferenced>>,
      TError,
      {
        resource: string;
        resourceVersion: string;
        pk: string;
        params?: GetRecordDereferencedParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getRecordDereferenced>>,
  TError,
  { resource: string; resourceVersion: string; pk: string; params?: GetRecordDereferencedParams },
  TContext
> => {
  return useMutation(getGetRecordDereferencedMutationOptions(options), queryClient);
};
export type patchBusinessObjectPropertyResponse202 = {
  data: void;
  status: 202;
};

export type patchBusinessObjectPropertyResponse400 = {
  data: void;
  status: 400;
};

export type patchBusinessObjectPropertyResponse404 = {
  data: void;
  status: 404;
};

export type patchBusinessObjectPropertyResponseSuccess = patchBusinessObjectPropertyResponse202 & {
  headers: Headers;
};
export type patchBusinessObjectPropertyResponseError = (
  | patchBusinessObjectPropertyResponse400
  | patchBusinessObjectPropertyResponse404
) & {
  headers: Headers;
};

export type patchBusinessObjectPropertyResponse =
  | patchBusinessObjectPropertyResponseSuccess
  | patchBusinessObjectPropertyResponseError;

export const getPatchBusinessObjectPropertyUrl = (
  resource: string,
  resourceVersion: string,
  pk: string,
  property: string,
) => {
  return `/record-service/v1/${resource}/${resourceVersion}/${pk}/property/${property}`;
};

/**
 * Accepted asynchronously. The response includes an `Operation-Location`
 * header pointing at `/record-service/v1/operations/{operationId}` which
 * can be polled (see `getOperationStatus`) for terminal status.
 * @summary Patch a specific property of a business object (flat merge)
 */
export const patchBusinessObjectProperty = async (
  resource: string,
  resourceVersion: string,
  pk: string,
  property: string,
  businessObject: BusinessObject,
  options?: Parameters<typeof customFetch>[1],
): Promise<patchBusinessObjectPropertyResponse> => {
  return customFetch<patchBusinessObjectPropertyResponse>(
    getPatchBusinessObjectPropertyUrl(resource, resourceVersion, pk, property),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(businessObject),
    },
  );
};

export const getPatchBusinessObjectPropertyQueryKey = (
  resource: string,
  resourceVersion: string,
  pk: string,
  property: string,
  businessObject?: BusinessObject,
) => {
  return [
    "PATCH",
    `/record-service/v1/${resource}/${resourceVersion}/${pk}/property/${property}`,
    businessObject,
  ] as const;
};

export const getPatchBusinessObjectPropertyQueryOptions = <
  TData = Awaited<ReturnType<typeof patchBusinessObjectProperty>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  property: string,
  businessObject: BusinessObject,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof patchBusinessObjectProperty>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPatchBusinessObjectPropertyQueryKey(resource, resourceVersion, pk, property, businessObject);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof patchBusinessObjectProperty>>> = ({
    signal,
  }) =>
    patchBusinessObjectProperty(resource, resourceVersion, pk, property, businessObject, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled:
      resource !== null &&
      resource !== undefined &&
      resourceVersion !== null &&
      resourceVersion !== undefined &&
      pk !== null &&
      pk !== undefined &&
      property !== null &&
      property !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof patchBusinessObjectProperty>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type PatchBusinessObjectPropertyQueryResult = NonNullable<
  Awaited<ReturnType<typeof patchBusinessObjectProperty>>
>;
export type PatchBusinessObjectPropertyQueryError = void;

export function usePatchBusinessObjectProperty<
  TData = Awaited<ReturnType<typeof patchBusinessObjectProperty>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  property: string,
  businessObject: BusinessObject,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof patchBusinessObjectProperty>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof patchBusinessObjectProperty>>,
          TError,
          Awaited<ReturnType<typeof patchBusinessObjectProperty>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePatchBusinessObjectProperty<
  TData = Awaited<ReturnType<typeof patchBusinessObjectProperty>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  property: string,
  businessObject: BusinessObject,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof patchBusinessObjectProperty>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof patchBusinessObjectProperty>>,
          TError,
          Awaited<ReturnType<typeof patchBusinessObjectProperty>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePatchBusinessObjectProperty<
  TData = Awaited<ReturnType<typeof patchBusinessObjectProperty>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  property: string,
  businessObject: BusinessObject,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof patchBusinessObjectProperty>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Patch a specific property of a business object (flat merge)
 */

export function usePatchBusinessObjectProperty<
  TData = Awaited<ReturnType<typeof patchBusinessObjectProperty>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  property: string,
  businessObject: BusinessObject,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof patchBusinessObjectProperty>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPatchBusinessObjectPropertyQueryOptions(
    resource,
    resourceVersion,
    pk,
    property,
    businessObject,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export type patchBusinessObjectPropertySyncResponse200 = {
  data: BusinessObject;
  status: 200;
};

export type patchBusinessObjectPropertySyncResponse400 = {
  data: void;
  status: 400;
};

export type patchBusinessObjectPropertySyncResponse404 = {
  data: void;
  status: 404;
};

export type patchBusinessObjectPropertySyncResponseSuccess =
  patchBusinessObjectPropertySyncResponse200 & {
    headers: Headers;
  };
export type patchBusinessObjectPropertySyncResponseError = (
  | patchBusinessObjectPropertySyncResponse400
  | patchBusinessObjectPropertySyncResponse404
) & {
  headers: Headers;
};

export type patchBusinessObjectPropertySyncResponse =
  | patchBusinessObjectPropertySyncResponseSuccess
  | patchBusinessObjectPropertySyncResponseError;

export const getPatchBusinessObjectPropertySyncUrl = (
  resource: string,
  resourceVersion: string,
  pk: string,
  property: string,
) => {
  return `/record-service/v1/${resource}/${resourceVersion}/${pk}/property/${property}/sync`;
};

/**
 * @summary Patch a specific property synchronously
 */
export const patchBusinessObjectPropertySync = async (
  resource: string,
  resourceVersion: string,
  pk: string,
  property: string,
  businessObject: BusinessObject,
  options?: Parameters<typeof customFetch>[1],
): Promise<patchBusinessObjectPropertySyncResponse> => {
  return customFetch<patchBusinessObjectPropertySyncResponse>(
    getPatchBusinessObjectPropertySyncUrl(resource, resourceVersion, pk, property),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(businessObject),
    },
  );
};

export const getPatchBusinessObjectPropertySyncQueryKey = (
  resource: string,
  resourceVersion: string,
  pk: string,
  property: string,
  businessObject?: BusinessObject,
) => {
  return [
    "PATCH",
    `/record-service/v1/${resource}/${resourceVersion}/${pk}/property/${property}/sync`,
    businessObject,
  ] as const;
};

export const getPatchBusinessObjectPropertySyncQueryOptions = <
  TData = Awaited<ReturnType<typeof patchBusinessObjectPropertySync>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  property: string,
  businessObject: BusinessObject,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof patchBusinessObjectPropertySync>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPatchBusinessObjectPropertySyncQueryKey(
      resource,
      resourceVersion,
      pk,
      property,
      businessObject,
    );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof patchBusinessObjectPropertySync>>> = ({
    signal,
  }) =>
    patchBusinessObjectPropertySync(resource, resourceVersion, pk, property, businessObject, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled:
      resource !== null &&
      resource !== undefined &&
      resourceVersion !== null &&
      resourceVersion !== undefined &&
      pk !== null &&
      pk !== undefined &&
      property !== null &&
      property !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof patchBusinessObjectPropertySync>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PatchBusinessObjectPropertySyncQueryResult = NonNullable<
  Awaited<ReturnType<typeof patchBusinessObjectPropertySync>>
>;
export type PatchBusinessObjectPropertySyncQueryError = void;

export function usePatchBusinessObjectPropertySync<
  TData = Awaited<ReturnType<typeof patchBusinessObjectPropertySync>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  property: string,
  businessObject: BusinessObject,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof patchBusinessObjectPropertySync>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof patchBusinessObjectPropertySync>>,
          TError,
          Awaited<ReturnType<typeof patchBusinessObjectPropertySync>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePatchBusinessObjectPropertySync<
  TData = Awaited<ReturnType<typeof patchBusinessObjectPropertySync>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  property: string,
  businessObject: BusinessObject,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof patchBusinessObjectPropertySync>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof patchBusinessObjectPropertySync>>,
          TError,
          Awaited<ReturnType<typeof patchBusinessObjectPropertySync>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePatchBusinessObjectPropertySync<
  TData = Awaited<ReturnType<typeof patchBusinessObjectPropertySync>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  property: string,
  businessObject: BusinessObject,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof patchBusinessObjectPropertySync>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Patch a specific property synchronously
 */

export function usePatchBusinessObjectPropertySync<
  TData = Awaited<ReturnType<typeof patchBusinessObjectPropertySync>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  property: string,
  businessObject: BusinessObject,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof patchBusinessObjectPropertySync>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPatchBusinessObjectPropertySyncQueryOptions(
    resource,
    resourceVersion,
    pk,
    property,
    businessObject,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export type workflowDefinitionLifecycleCommandResponse200 = {
  data: void;
  status: 200;
};

export type workflowDefinitionLifecycleCommandResponse400 = {
  data: void;
  status: 400;
};

export type workflowDefinitionLifecycleCommandResponse404 = {
  data: void;
  status: 404;
};

export type workflowDefinitionLifecycleCommandResponse409 = {
  data: void;
  status: 409;
};

export type workflowDefinitionLifecycleCommandResponse503 = {
  data: void;
  status: 503;
};

export type workflowDefinitionLifecycleCommandResponseSuccess =
  workflowDefinitionLifecycleCommandResponse200 & {
    headers: Headers;
  };
export type workflowDefinitionLifecycleCommandResponseError = (
  | workflowDefinitionLifecycleCommandResponse400
  | workflowDefinitionLifecycleCommandResponse404
  | workflowDefinitionLifecycleCommandResponse409
  | workflowDefinitionLifecycleCommandResponse503
) & {
  headers: Headers;
};

export type workflowDefinitionLifecycleCommandResponse =
  | workflowDefinitionLifecycleCommandResponseSuccess
  | workflowDefinitionLifecycleCommandResponseError;

export const getWorkflowDefinitionLifecycleCommandUrl = (
  resource: string,
  resourceVersion: string,
  pk: string,
) => {
  return `/record-service/v1/${resource}/${resourceVersion}/${pk}/lifecycle-commands`;
};

/**
 * Changes a WorkflowDefinition/1.0.0 from PUBLISHED to DEPRECATED or DEPRECATED to RETIRED.
 * Generic PUT and PATCH cannot perform these transitions. The command is idempotent.
 * @summary Apply a workflow definition lifecycle command
 */
export const workflowDefinitionLifecycleCommand = async (
  resource: string,
  resourceVersion: string,
  pk: string,
  workflowDefinitionLifecycleCommandBody: WorkflowDefinitionLifecycleCommandBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<workflowDefinitionLifecycleCommandResponse> => {
  return customFetch<workflowDefinitionLifecycleCommandResponse>(
    getWorkflowDefinitionLifecycleCommandUrl(resource, resourceVersion, pk),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(workflowDefinitionLifecycleCommandBody),
    },
  );
};

export const getWorkflowDefinitionLifecycleCommandQueryKey = (
  resource: string,
  resourceVersion: string,
  pk: string,
  workflowDefinitionLifecycleCommandBody?: WorkflowDefinitionLifecycleCommandBody,
) => {
  return [
    "POST",
    `/record-service/v1/${resource}/${resourceVersion}/${pk}/lifecycle-commands`,
    workflowDefinitionLifecycleCommandBody,
  ] as const;
};

export const getWorkflowDefinitionLifecycleCommandQueryOptions = <
  TData = Awaited<ReturnType<typeof workflowDefinitionLifecycleCommand>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  workflowDefinitionLifecycleCommandBody: WorkflowDefinitionLifecycleCommandBody,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof workflowDefinitionLifecycleCommand>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getWorkflowDefinitionLifecycleCommandQueryKey(
      resource,
      resourceVersion,
      pk,
      workflowDefinitionLifecycleCommandBody,
    );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof workflowDefinitionLifecycleCommand>>> = ({
    signal,
  }) =>
    workflowDefinitionLifecycleCommand(
      resource,
      resourceVersion,
      pk,
      workflowDefinitionLifecycleCommandBody,
      { signal, ...requestOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled:
      resource !== null &&
      resource !== undefined &&
      resourceVersion !== null &&
      resourceVersion !== undefined &&
      pk !== null &&
      pk !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof workflowDefinitionLifecycleCommand>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkflowDefinitionLifecycleCommandQueryResult = NonNullable<
  Awaited<ReturnType<typeof workflowDefinitionLifecycleCommand>>
>;
export type WorkflowDefinitionLifecycleCommandQueryError = void;

export function useWorkflowDefinitionLifecycleCommand<
  TData = Awaited<ReturnType<typeof workflowDefinitionLifecycleCommand>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  workflowDefinitionLifecycleCommandBody: WorkflowDefinitionLifecycleCommandBody,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof workflowDefinitionLifecycleCommand>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workflowDefinitionLifecycleCommand>>,
          TError,
          Awaited<ReturnType<typeof workflowDefinitionLifecycleCommand>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWorkflowDefinitionLifecycleCommand<
  TData = Awaited<ReturnType<typeof workflowDefinitionLifecycleCommand>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  workflowDefinitionLifecycleCommandBody: WorkflowDefinitionLifecycleCommandBody,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof workflowDefinitionLifecycleCommand>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workflowDefinitionLifecycleCommand>>,
          TError,
          Awaited<ReturnType<typeof workflowDefinitionLifecycleCommand>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWorkflowDefinitionLifecycleCommand<
  TData = Awaited<ReturnType<typeof workflowDefinitionLifecycleCommand>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  workflowDefinitionLifecycleCommandBody: WorkflowDefinitionLifecycleCommandBody,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof workflowDefinitionLifecycleCommand>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Apply a workflow definition lifecycle command
 */

export function useWorkflowDefinitionLifecycleCommand<
  TData = Awaited<ReturnType<typeof workflowDefinitionLifecycleCommand>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  pk: string,
  workflowDefinitionLifecycleCommandBody: WorkflowDefinitionLifecycleCommandBody,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof workflowDefinitionLifecycleCommand>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getWorkflowDefinitionLifecycleCommandQueryOptions(
    resource,
    resourceVersion,
    pk,
    workflowDefinitionLifecycleCommandBody,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}
